import { enumRecordToCheckboxOptions } from '@umss/shared/utils';

export enum BankAccountType {
  CHECKING = 'checking',
  SAVINGS = 'savings'
}

export const BankAccountTypeLabels: Record<BankAccountType, string> = {
  [BankAccountType.CHECKING]: 'Checking',
  [BankAccountType.SAVINGS]: 'Savings'
};

export const BANK_ACCOUNT_TYPE_OPTIONS = enumRecordToCheckboxOptions(
  BankAccountTypeLabels
);
